import HttpHelper from "./http";
import { IOriginSelector } from "./utils";

const LATENCY_RETRIES = 4;
export const DEFAULT_REGION: IOriginSelector = {
  label: 'Automatic',
  value: 'automatic',
  url: null,
  ping: null,
  iconClass: null,
};

export default class LatencyHelper {
  static async checkUrlNetworkLatency(url, retries = LATENCY_RETRIES): Promise<number> {
    let latency = null;

    for (let index = 0; index < retries; index++) {
      try {
        const response = await HttpHelper.getWithStats(url, { background: true });
        const ping = response.latency;

        if (!latency || latency < ping) {
          latency = ping;
        }
      } catch (error) {

      }
    }

    return latency;
  }

  static get defaultAvailableRegions(): IOriginSelector[] {
    return [
      {
        label: 'Automatic',
        value: 'automatic',
        url: null,
        ping: null,
        iconClass: null,
      },
      {
        label: 'US West',
        value: 'us-west',
        url: 'https://us-west-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
      {
        label: 'US Central',
        value: 'us-central',
        url: 'https://us-central-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
      {
        label: 'US East',
        value: 'us-east',
        url: 'https://us-east-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
      {
        label: 'EU West',
        value: 'eu-west',
        url: 'https://eu-west-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
      {
        label: 'AP Southeast',
        value: 'ap-southeast',
        url: 'https://ap-southeast-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
      {
        label: 'AP West',
        value: 'ap-west',
        url: 'https://ap-west-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
      {
        label: 'SA East',
        value: 'sa-east',
        url: 'https://sa-east-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
    ];
  }

  static get defaultAvailableStageRegions(): IOriginSelector[] {
    return [
      {
        label: 'Automatic',
        value: 'automatic',
        url: null,
        ping: null,
        iconClass: null,
      },
      {
        label: 'US West Stage',
        value: 'us-west-stage',
        url: 'https://us-west-stage.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
      {
        label: 'US Central Stage',
        value: 'us-central-stage',
        url: 'https://stage-ingest.streamlabsstudio.com:444/ping',
        ping: null,
        iconClass: null,
      },
    ];
  }

  static async getRegionsWithLatency(): Promise<IOriginSelector[]> {
    const regions = process.env.MIX_ENV !== 'development' ? LatencyHelper.defaultAvailableRegions : LatencyHelper.defaultAvailableStageRegions;

    regions.forEach(async (region) => {
      if (region.url) {
        region.ping = await LatencyHelper.checkUrlNetworkLatency(region.url);

        if (!region.ping) return;

        if (region.ping < 100) {
          region.iconClass = 'icon-check-mark recommendation-color';
          return;
        }

        if (region.ping < 150) {
          region.iconClass = 'icon-check-mark recommendation-color';
          return;
        }

        if (region.ping < 200) {
          region.iconClass = 'icon-information alert-color';
          return;
        }

        if (region.ping < 300) {
          region.iconClass = 'icon-close warning-color';
          return;
        }

        region.iconClass = 'icon-close warning-color';
      }
    });

    return regions
      .sort((regionA, regionB) => {
        const pingA = regionA.value !== 'automatic' ? regionA.ping : 0;
        const pingB = regionB.value !== 'automatic' ? regionB.ping : 0;
        return pingA - pingB;
      });
  }
}